import { Auth0Role } from '../auth0/auth0.models';

/** Wildcard scope — grants access to all scopes */
export const SCOPE_WILDCARD = '*';

/** Delimiter between domain and action in scope strings (e.g., `campaigns:create`) */
export const SCOPE_DELIMITER = ':';

/** Suffix for domain-level wildcard scopes (e.g., `campaigns:*`) */
export const SCOPE_DOMAIN_WILDCARD_SUFFIX = `${SCOPE_DELIMITER}*`;

/**
 * Regex for validating individual scope strings.
 *
 * Valid formats:
 *   `*`                              → global wildcard
 *   `external`                       → bare domain
 *   `external:*`                     → domain wildcard
 *   `campaigns:get-all`              → domain:action
 *   `external:campaigns:*`           → multi-level wildcard
 *   `external:campaigns:get-all`     → multi-level exact
 *
 * Segments are lowercase letters with hyphens (no numbers). Wildcard `*` is
 * only valid as the entire scope or as the final segment after a colon.
 */
export const SCOPE_PATTERN = /^\*$|^[a-z][a-z-]*(:[a-z][a-z-]*)*(:\*)?$/;

const API_KEY_PREFIX = 'api-key';

/** Generates a user ID for an API key (used in auth context and principalId) */
export const getApiKeyUserId = (apiKeyId: string) => `${API_KEY_PREFIX}|${apiKeyId}`;

export const VALID_API_KEY_ROLES: Auth0Role[] = [
  Auth0Role.GR_ADMIN,
  Auth0Role.GR_STAFF_MANAGER,
  Auth0Role.GR_STAFF_USER,
];
